import { makeStyles } from '@material-ui/core';
import logoFull from './logo-full.svg';

const useStyles = makeStyles({
  img: {
    maxWidth: 150,
    height: 'auto',
  },
});

export const LogoFull = () => {
  const classes = useStyles();
  return <img className={classes.img} src={logoFull} alt="Goals" />;
};

